const ReferenceData = {
    AVAILABLE_LOCALES: [
        {
            code: "en_US",
            name: "English (US)"
        }
    ],
    FUND_LINEUP_STATUS: {
        PENDING: "pending",
        INELIGIBLE: "ineligible",
        FAILED: "failed",
        ACTIVE: "active",
        NO_LINEUP: "no_lineup"
    },
    MOBILE_TABLET_PHONE_WIDTH: 960,

    ACCESS_DENIED_URL: "/participant/accounts/#/accessDeniedError/44403",
    ACCTS_CUSTOMIZATON_RETRIEVAL_URL: "customizations/{accu}/{accu}{suffixPath}",
    ACCOUNT_DETAILS_MOCK: "/participant/accounts/assets/data/get-account-details.json",
    ACCOUNT_DETAILS_URL: "/participant-web-services/rest/accounts/account/{individualId}/{groupId}",
    ACCOUNT_DETAILS_SUMMARY_URL: "/participant-web-services/rest/accounts/summary",
    ACCOUNT_MENU_URL: "/participant-web-services/rest/menu/getAccountMenuDetails",
    ACCOUNT_SUMMARY_MOCK: "assets/data/get-account-summary.json",
    ACCOUNT_SUMMARY_URL: "/participant-web-services/rest/accounts/summary",
    ACCOUNT_SUMMARY_REFRESH: "/participant-web-services/rest/accounts/summary?refreshAccountsList",
    ACTIVITY_URL: "/participant-web-services/rest/nonauth/service/activity",
    ADVICE_PAGE_URL: "/participant/home/#/advice",
    ALLOCATIONS_SELECTION: "/#/guidance/allocations/selection",
    ALLOCATIONS_SELECTION_W_EQTY_TARGET:
        "/guidance/allocations/selection/{userEquityTargetPercentage}",
    AUTH_DATA_URL: "/participant-web-services/rest/nonauth/isAuthenticated",
    ENTERPRISE_CHAT_AVAILABILITY: "/participant-web-services/rest/partialauth/chat/availability",
    ENTERPRISE_CHAT_EXECUTE: "/participant-web-services/rest/partialauth/chat/execute",
    CLEAR_LANGUAGE_COOKIES: "/participant-web-services/rest/nonauth/clearLanguageCookies",
    CLEAR_ENGLISH_LANG_COOKIES: "/participant-web-services/rest/nonauth/setAccuCodeCookies",
    CLEAR_SPANISH_LANG_COOKIES:
        "/participant-web-services/rest/nonauth/clearSpanishLanguageCookies",
    DEFAULT_ACCTS_CUST_RETRIEVAL_URL: "customizations/Default/AccountsDefaultCustomization.json",
    DEFAULT_CUSTOM_LOGO_INVENTORY: "customizations/Default/logoCustomizationInventory.json",
    ELIGIBILITY_URL: "/participant-web-services/rest/home/eligibility",
    FREEMIUM_DASHBOARD: "/dashboard/#/home",
    GET_FE_SAML_TOKEN: "/participant-web-services/rest/sso/femaSaml",
    GET_FE_SAML_TOKEN_FOR_PLAN:
        "/participant-web-services/rest/sso/femaSaml/indId/{individualId}/group/{groupId}?pagecode={pagecode}&treatment={treatment}&lastAlert={lastAlert}&clickthrough={clickthrough}",
    GET_TAS_SSO_URL:
        "/participant-web-services/rest/sso/tasSSO/indId/{individualId}/group/{groupId}",
    GET_INTEGRATED_ELIGIBILITY: "/participant-web-services/rest/home/eligibility",
    GET_SITE_CONTACT_INFO: "/participant-web-services/rest/sitecontactinfo/{gaId}",
    GET_SITE_CONTACT_INFO_PRELOGIN:
        "/participant-web-services/rest/nonauth/getPreLoginContactInfoByAccu/{accu}/{accuSpecificPrimDb}/{portalType}",
    GET_TOPNAV_LINKS: "/participant-web-services/rest/menu/topNavLinks",
    GET_TOPNAV_LINKS_REFRESH: "/participant-web-services/rest/menu/topNavLinks?refreshAccountsList",
    GROUP_MENU_URL: "/participant-web-services/rest/menu/getGroupNavigationMenu/groupId/{groupId}",
    HDR_PLAN_MSGS_URL:
        "/participant-web-services/rest/nonauth/bulletins/bulletinsForGrps/function/KP",
    INVESTMENT_OPTIONS_OVERVIEW:
        "/#/account/{individualId}/{groupId}/investment-options/investment-overview?ignoreDuplicateSets=true",
    INVESTMENT_OVERVIEW_GET_BASIC:
        "/participant-web-services/rest/investments/services/{individualId}/{groupId}/guidanceInfo",
    IS_PAE_USER: "/participant-web-services/rest/sso/isPAEUser",
    INTEGRATED_DASHBOARD: "/participant/home/#/dashboard/retirement-income",
    KEEP_ALIVE_URL: "/participant-web-services/rest/nonauth/keepAlive",
    LOGIN_APP_URL: "/participant",
    LOGIN_URL_W_ACCU: "/participant/#/login?accu=",
    LOGOUT_LEGACY_URL: "/logoutNextgen.do",
    LOGOUT_SVC_URL: "/participant-web-services/rest/nonauth/logOut",
    PARTICIPANT_APP_URL: "/participant/accounts",
    PARTICIPANT_OVERVIEW_URL: "/participant/accounts/#/overview",
    PRIMARY_PLAN_URL: "/participant-web-services/rest/accounts/primaryPlan",
    PRIMARY_PLAN_BY_IND_ID:
        "/participant-web-services/rest/accounts/primaryPlanByIndId/{individualId}/{dbName}?accuCode={accuCode}",
    PROFILE_MOBILE: "/#/profile?accu={accuCode}",
    PSC_PATH_URL: "/participant-web-services/rest/nonauth/getPSCPath",
    PSC_PATH_DEFAULT_URL: "https://proj4-plan.retirementpartner.com/psc/?accu=PlanEmpower",
    RETIREMENT_INCOME_URL: "/participant/home/#/dashboard/retirement-income",
    RETRIEVE_LANGUAGE_CODE:
        "/participant-web-services/rest/partialauth/profile/retrieveLanguageCode",
    SAVINGS_AND_BILL: "/participant/accounts/#/savingsAndBill",
    SET_ACCU_CODE_COOKIES: "/participant-web-services/rest/nonauth/setAccuCodeCookies",
    SET_LANGUAGE_COOKIES: "/participant-web-services/rest/partialauth/profile/setSpnLangCookies",
    SHOW_TOTAL_REWARDS: "/participant-web-services/rest/accounts/hasCharltonPartService",
    TXN_ACCESS_URL: "/participant-web-services/rest/primaryPlan/hasTxnAccess/",
    UPDATE_NEW_ACCT_CONTEXT:
        "/participant-web-services/rest/partialauth/oneId/retrieveNewAccountInfo?refreshAccountsList",
    UPDATE_DEFAULT_PLAN:
        "/participant-web-services/rest/partialauth/oneId/refreshSessionWithContextSwitch/{individualId}/{dbName}/{accuCode}/{updateDefault}?gaId={gaId}",
    UPDATE_LANGUAGE_CODE: "/participant-web-services/rest/partialauth/profile/updateLanguageCode",
    USER_PROFILE_URL: "/participant-web-services/rest/accounts/user/profile",
    BANK_ACCOUNTS_URL:
        "/participant-web-services/rest/partBankAccount/getBankAccounts?gaId={groupId}&indId={individualId}&usageType={usageType}&active=true",
    BANK_ACCOUNTS_URL_CHANGE_PAYMENT:
        "/participant-web-services/rest/partBankAccount/getBankAccounts?gaId={groupId}&indId={individualId}&active=true",
    CLEAR_IBBOTSON_URL:
        "/participant-web-services/rest/investments/services/ibbotsonReturn/{groupId}",
    PROVIDER_URL_AND_PHONE_NUMBER_API:
        "/participant-web-services/rest/accounts/{individualId}/{groupId}/getProviderUrlAndPhoneNumber",
    GET_GROUP_TXN_ACCESS:
        "/participant-web-services/rest/groupTxnAccess/{individualId}/{groupId}/txnCodes/{txnCodes}",
    GET_MA_DETAILS:
        "/participant-web-services/rest/accounts/account/MAEnrollmentDetails/{individualId}/{groupId}",
    GET_NQ_ENROLL_ELIGIBILITY:
        "/participant-web-services/rest/nonqual/isParticipantEnrollmentEligible/{groupId}",

    SAML_TOKEN_API_URLS: {
        getComputerShareSamlTokenApi:
            "/participant-web-services/rest/sso/computerShareSaml/individualId/{individualId}/groupId/{groupId}",
        getPrudentialSamlTokenApi:
            "/participant-web-services/rest/sso/prudentialSSO/indId/{individualId}/group/{groupId}",
        getJPMorganSamlTokenApi:
            "/participant-web-services/rest/sso/jpmorganSSO/indId/{individualId}/group/{groupId}",
        getCharltonSamlTokenApi:
            "/participant-web-services/rest/sso/charltonSSO/indId/{individualId}/group/{groupId}",
        showTotalRewardsApi: "/participant-web-services/rest/accounts/hasCharltonPartService",
        getMillimanSamlTokenApi:
            "/participant-web-services/rest/sso/millimanSSO/indId/{individualId}/group/{groupId}",
        getDNPSamlTokenApi:
            "/participant-web-services/rest/sso/dnpSSO/indId/{individualId}/group/{groupId}",
        getHewittSamlTokenApi:
            "/participant-web-services/rest/sso/ipAonHewittSSO/indId/{individualId}/group/{groupId}",
        getBPSSamlTokenApi:
            "/participant-web-services/rest/sso/bpsSSO/indId/{individualId}/group/{groupId}",
        getOptumSamlTokenApi:
            "/participant-web-services/rest/sso/optumSSO/indId/{individualId}/group/{groupId}",
        getNewportSamlTokenApi:
            "/participant-web-services/rest/sso/newportSSO/indId/{individualId}/group/{groupId}",
        getOctober3SamlTokenApi:
            "/participant-web-services/rest/sso/october3SSO/indId/{individualId}/group/{groupId}",
        getNewportAppleSamlTokenApi:
            "/participant-web-services/rest/sso/newportAppleSSO/indId/{individualId}/group/{groupId}",
        getFindleySamlTokenApi:
            "/participant-web-services/rest/sso/findleySSO/indId/{individualId}/group/{groupId}",
        getAonSamlTokenApi:
            "/participant-web-services/rest/sso/aonSSO/indId/{individualId}/group/{groupId}",
        getCBNSamlTokenApi:
            "/participant-web-services/rest/sso/commonBondSSO/indId/{individualId}/group/{groupId}",
        getCBNInstSamlTokenApi:
            "/participant-web-services/rest/sso/commonBondSSOInst/indId/{individualId}/group/{groupId}",
        getRiteAidSamlTokenApi:
            "/participant-web-services/rest/sso/riteAidSSO/indId/{individualId}/group/{groupId}",
        getTRSMillimanSamlTokenApi:
            "/participant-web-services/rest/sso/millimantrsSSO/indId/{individualId}/group/{groupId}",
        getHSABankSamlTokenApi:
            "/participant-web-services/rest/sso/hsaBankSSO/indId/{individualId}/group/{groupId}",
        getPershingSamlTokenApi:
            "/participant-web-services/rest/sso/pershingSSO/indId/{individualId}/group/{groupId}",
        getAbbvieSamlTokenApi:
            "/participant-web-services/rest/sso/abbvieSSO/indId/:individualId/group/:groupId",
        getEtradeSamlTokenApi:
            "/participant-web-services/rest/sso/etradeSSO/indId/:individualId/group/:groupId",
        getMyDeferralSamlTokenApi:
            "/participant-web-services/rest/sso/myDeferralSSO/indId/:individualId/group/:groupId",
        getThreeMSamlTokenApi:
            "/participant-web-services/rest/sso/threeMSSO/indId/:individualId/group/:groupId",
        getMilliman2SamlTokenApi:
            "/participant-web-services/rest/sso/milliman2SSO/indId/:individualId/group/:groupId",
        getCandidlySamlTokenApi:
            "/participant-web-services/rest/sso/candidlySSO/indId/:individualId/group/:groupId",
        getBlueRidgeSamlTokenApi:
            "/participant-web-services/rest/sso/blueridgeSSO/indId/:individualId/group/:groupId",
        getWellspanSamlTokenApi:
            "/participant-web-services/rest/sso/wellspanSSO/indId/:individualId/group/:groupId",
        getOptumCycSamlTokenApi:
            "/participant-web-services/rest/sso/optumcycSSO/indId/:individualId/group/:groupId"
    },

    ROUTES_TO_CHECK: [
        "/retirement-income",
        "/social-security",
        "/other-assets",
        "/income-gap",
        "/dashboard/hsa",
        "/healthcare-costs",
        "/how-do-i-compare",
        "/maximizer",
        "/pre-retirement"
    ],

    PREVENT_NAVIGATION_URLS_URL_ARRAY: [
        "/withdrawal/advisory",
        "/withdrawal/nonrothallocations",
        "/withdrawal/rothallocations",
        "/withdrawal/beneficiary",
        "/withdrawal/accumulation",
        "/distribution/types",
        "/distribution/reasons",
        "/distribution/amount",
        "/distribution/citizenship-verification",
        "/distribution/review",
        "/distribution/employment-check",
        "/loan/reasons",
        "/loan/quotes",
        "loan/loanRepayment",
        "/loan/updates",
        "/loan/requestSummary",
        "/loan/principalResidenceReqDoc",
        "/rmd/request",
        "/rmd/citizenship-verification"
    ],
    errorModal: {
        FEATURE_NOT_AVAILABLE:
            "This feature is not available until you complete the steps to open your new account",
        UNAUTHORIZED: "You are not authorized to view this page.",
        HEADING_TITLE: "Unable to continue.",
        PAE_MESSAGES: [
            {
                MSG: "Non participant users are prohibited from navigating to this page.",
                CODE: "PAE002"
            }
        ],
        ACCOUNT_OPENING_IN_PROGRESS: {
            TITLE: "Account Opening",
            MSG: "Account Opening still in progress. Please click 'Done' to complete."
        }
    },
    LANGUAGES: {
        ENG: "ENG",
        SPN: "SPN"
    },
    PC_API: {
        MESSAGES: {
            GET_USER_MESSAGES: "/api/message/getUserMessages",
            UPDATE_USER_MESSAGES: "/api/message/updateUserMessages"
        },
        AUTH: {
            SWITCH_USER: "/api/login/switchUser"
        },
        FUNNEL_ATTRIBUTES: {
            GET_FUNNEL_ATTRIBUTES: "/api/profile/getFunnelAttributes"
        },
        ACCOUNTS: {
            GET_ACCOUNTS_LIST: "/api/newaccount/getAccounts2"
        },
        UI_PREFERENCES: {
            GET_UI_PREFERENCES: "/api/profile/getUIPreferences"
        }
    },
    CHAT: {
        PLATFORM: "Web"
    },
    USER_TYPE_PARTICIPANT: "PARTICIPANT",
    USER_TYPE_PRIVILEGED: "PRIVILEGED",
    USER_TYPE_PAE: "PAE",
    HAS_RETAIL_ACCOUNT: {
        SITE_NAME: ["empower-retail-pcap", "empower-retail-pcap-ps", "empower-retail-pcap-cash"]
    }
};

export default ReferenceData;
